import React from 'react';
import propTypes from './propTypes';

const AboutService = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M20.9996 6.50078C20.9996 8.43078 19.4296 10.0008 17.4996 10.0008C17.0896 10.0008 16.6996 9.92078 16.3396 9.79078L4.95961 21.1608L2.83961 19.0408L10.2496 11.6308L8.46961 9.85078L7.75961 10.5608L6.34961 9.15078V11.9808L5.63961 12.6908L2.09961 9.15078L2.80961 8.44078H5.62961L4.21961 7.03078L7.75961 3.49078C8.92961 2.32078 10.8296 2.32078 11.9996 3.49078L9.87961 5.61078L11.2896 7.02078L10.5796 7.73078L12.3596 9.51078L14.2096 7.66078C14.0796 7.30078 13.9996 6.91078 13.9996 6.50078C13.9996 4.57078 15.5696 3.00078 17.4996 3.00078C18.0796 3.00078 18.6196 3.16078 19.0996 3.41078L16.3996 6.11078L17.8896 7.60078L20.5896 4.90078C20.8396 5.38078 20.9996 5.92078 20.9996 6.50078Z" fill="currentColor" />
    <path d="M13.7822 15.1719L15.9035 13.0506L21.8997 19.0468L19.7784 21.1681L13.7822 15.1719Z" fill="currentColor" />
  </svg>
);

AboutService.propTypes = propTypes;

export default AboutService;
